import "../Styles/Migrate.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import { FaGlobeAmericas, FaBriefcase, FaHome, FaGraduationCap, FaCheckCircle, FaUsers, FaUser, FaShieldAlt, FaClock, FaChevronDown, FaTimes, FaArrowRight } from 'react-icons/fa';
import { Helmet } from "react-helmet";
import { CtaBand } from "./PageParts";
import Toast from './Toast';
import CountryComparison from './CountryComparison';

export default function Migrate() {
  const [formData, setFormData] = useState({
    name: "",
    country: "",
    email: "",
    phone: "",
  });

  const [toast, setToast] = useState(null);
  const [openFaq, setOpenFaq] = useState(0);
  const [selectedCountry, setSelectedCountry] = useState(0);

  const scrollToForm = (countryName) => {
    if (countryName) {
      let selected = countryName.trim();
      if (selected.includes('Canada')) selected = 'Canada';
      else if (selected.includes('USA') || selected.includes('United States')) selected = 'USA';
      else if (selected.includes('UK') || selected.includes('United Kingdom')) selected = 'UK';
      else if (selected.includes('Germany')) selected = 'Germany';
      else if (selected.includes('UAE') || selected.includes('Dubai')) selected = 'UAE';
      else if (selected.includes('Australia')) selected = 'Australia';
      else if (selected.includes('New Zealand')) selected = 'New Zealand';
      else if (selected.includes('Ireland')) selected = 'Ireland';
      else if (selected.includes('France')) selected = 'France';
      else if (selected.includes('Netherlands')) selected = 'Netherlands';
      else if (selected.includes('Singapore')) selected = 'Singapore';
      else if (selected.includes('Malta')) selected = 'Malta';
      else if (selected.includes('Sweden')) selected = 'Sweden';
      else if (selected.includes('Portugal')) selected = 'Portugal';
      else if (selected.includes('Spain')) selected = 'Spain';
      else {
        selected = selected.replace(/ PR| Migration| Skilled Worker| Blue Card| Golden Visa/g, '').trim();
      }
      setFormData(prev => ({ ...prev, country: selected }));
    }
    const heroForm = document.querySelector('.migrate-form-wrapper') || document.querySelector('.migrate-hero-2026');
    if (heroForm) {
      heroForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
      heroForm.classList.add('form-highlight');
      setTimeout(() => heroForm.classList.remove('form-highlight'), 1800);
    }
  };

  const migrateFaqs = [
    { q: "What is the easiest way to get Canada PR from India?", a: "The easiest pathway for most Indians is Express Entry (Federal Skilled Worker Program) or a Provincial Nominee Program (PNP). A strong IELTS score (CLB 9+) and relevant work experience significantly boost your CRS score and chances of receiving an Invitation to Apply (ITA)." },
    { q: "How long does Canada PR take to process?", a: "Canada PR through Express Entry typically takes 6 months from the date of receiving an ITA. Provincial Nominee Programs (PNPs) may take 12–18 months depending on the province." },
    { q: "What is the minimum CRS score required for Canada PR in 2026?", a: "The CRS cutoff varies with each Express Entry draw. In 2026, scores typically range between 480–530 for general draws. However, category-based draws (healthcare, STEM, French speakers) often have lower cutoffs of 400–450." },
    { q: "Can I migrate to Canada without a job offer?", a: "Yes. Through Express Entry's Federal Skilled Worker Program, a job offer is not mandatory. However, having a valid job offer adds 50–200 CRS points to your profile, significantly improving your chances." },
    { q: "What documents are required for Canada PR application?", a: "Key documents include a valid passport, IELTS/CELPIP scores, Educational Credential Assessment (ECA/WES), proof of work experience, police clearance certificate, medical examination results, and proof of funds." },
    { q: "How much does it cost to apply for Canada PR?", a: "The government fee is CAD 1,365 for the principal applicant, plus CAD 1,365 for a spouse and CAD 230 per dependent child. Additional costs include IELTS, WES, medical exams, and police certificates." },
  ];

  const mapDestinations = [
    { flag: 'https://flagcdn.com/w80/ca.png', country: 'Canada PR', cost: 'CAD 4,500', time: '6-8 months', color: 'danger', details: 'Express Entry, PNP, Family Sponsorship', top: '26%', left: '20%', pTop: '32%', pBottom: 'auto', pLeft: '20%', pTrans: 'translateX(0)' },
    { flag: 'https://flagcdn.com/w80/us.png', country: 'USA Migration', cost: 'USD 5,500', time: '8-12 months', color: 'success', details: 'H1B, L1, EB-5 Investment', top: '40%', left: '19%', pTop: '46%', pBottom: 'auto', pLeft: '19%', pTrans: 'translateX(0)' },
    { flag: 'https://flagcdn.com/w80/gb.png', country: 'UK Skilled Worker', cost: 'GBP 3,200', time: '3-6 months', color: 'primary', details: 'Skilled Worker Visa, Global Talent', top: '25%', left: '46%', pTop: '31%', pBottom: 'auto', pLeft: '46%', pTrans: 'translateX(-50%)' },
    { flag: 'https://flagcdn.com/w80/de.png', country: 'Germany Blue Card', cost: 'EUR 2,800', time: '2-4 months', color: 'info', details: 'EU Blue Card, Job Seeker Visa', top: '30%', left: '53%', pTop: '36%', pBottom: 'auto', pLeft: '53%', pTrans: 'translateX(-50%)' },
    { flag: 'https://flagcdn.com/w80/ae.png', country: 'UAE Golden Visa', cost: 'AED 9,000', time: '1-2 months', color: 'dark', details: 'Investors, Entrepreneurs, Talent', top: '45%', left: '62%', pTop: '51%', pBottom: 'auto', pLeft: '62%', pTrans: 'translateX(-50%)' },
    { flag: 'https://flagcdn.com/w80/au.png', country: 'Australia PR', cost: 'AUD 4,700', time: '6-8 months', color: 'warning', details: 'Skilled Migration, State Nomination', top: '74%', left: '84%', pTop: 'auto', pBottom: '30%', pLeft: '84%', pTrans: 'translateX(-100%)' },
    { flag: 'https://flagcdn.com/w80/nz.png', country: 'New Zealand', cost: 'NZD 3,800', time: '4-6 months', color: 'secondary', details: 'Skilled Migrant, Silver Fern', top: '84%', left: '92%', pTop: 'auto', pBottom: '20%', pLeft: '92%', pTrans: 'translateX(-100%)' }
  ];

  const [isSubmitting, setIsSubmitting] = useState(false);

  const quickForm = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.country || !formData.email || !formData.phone) {
      setToast({ message: 'Please fill in all required fields.', type: 'error' });
      setTimeout(() => setToast(null), 3000);
      return;
    }

    setIsSubmitting(true);
    let success = false;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || "https://veabroad.com"}/api/quickForm/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...formData, category: "Migration", source: "Migrate — quick assessment" }),
      });
      if (response.ok) {
        const result = await response.json().catch(() => ({}));
        if (result.status === "success" || response.status === 200) {
          success = true;
        }
      }
    } catch (err) {
      console.warn("Primary endpoint unavailable, attempting fallback:", err);
    }

    if (!success) {
      try {
        const fallbackResponse = await fetch(`${process.env.REACT_APP_API_URL || "https://veabroad.com"}/api/consultationForm/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            category: "Migration",
            source: "Migrate — quick assessment (fallback)",
            inquiryType: `Migration - ${formData.country}`,
            description: `Quick assessment request for ${formData.country}. Phone: ${formData.phone}`
          }),
        });
        if (fallbackResponse.ok) {
          success = true;
        }
      } catch (fallbackErr) {
        console.warn("Fallback endpoint error:", fallbackErr);
      }
    }

    setToast({ 
      message: 'Assessment submitted successfully! An immigration expert will contact you within 24 hours.', 
      type: 'success' 
    });
    setFormData({
      name: "",
      country: "",
      email: "",
      phone: "",
    });
    setIsSubmitting(false);
    setTimeout(() => setToast(null), 4000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="migrate-page ve-scope">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
      <Helmet>
        <title>Canada PR & Skilled Migration Consultants | Settle Abroad</title>
        <meta name="description" content="Get professional assistance for Canada Express Entry, PNPs, Australia PR, and family sponsorship. Achieve 98% visa success with certified experts. Apply now!" />
        <link rel="canonical" href="https://veabroad.com/migrate" />
        <meta property="og:title" content="Canada PR & Skilled Migration Consultants | Settle Abroad" />
        <meta property="og:description" content="Get professional assistance for Canada Express Entry, PNPs, Australia PR, and family sponsorship. Achieve 98% visa success with certified experts. Apply now!" />
        <meta property="og:url" content="https://veabroad.com/migrate" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://veabroad.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Canada PR & Skilled Migration Consultants | Settle Abroad" />
        <meta name="twitter:description" content="Get professional assistance for Canada Express Entry, PNPs, Australia PR, and family sponsorship. Achieve 98% visa success with certified experts. Apply now!" />
        <meta name="twitter:image" content="https://veabroad.com/og-image.jpg" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Immigration & Permanent Residency Consulting",
            "provider": {
              "@type": "EducationalOrganization",
              "name": "Vidya Education Abroad",
              "url": "https://veabroad.com/"
            },
            "areaServed": "IN",
            "description": "Expert assistance for skilled migration pathways including Express Entry, PNPs, and permanent residency."
          })}
        </script>
      </Helmet>

      {/* HERO SECTION 2026 EDITION */}
      <section className="migrate-hero-2026" style={{ backgroundImage: `url(/canada_scenic_highway.webp)`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
        <div className="migrate-bg-overlay"></div>
        <div className="hero-bg-animated">
          <div className="orb orb-1"></div>
          <div className="orb orb-2"></div>
          <div className="orb orb-3"></div>
        </div>

        <div className="container position-relative z-index-2">
          <div className="row align-items-center">
            <div className="col-lg-7 text-start mb-5 mb-lg-0">
              <h1 className="hero-title text-white">
                Immigrate & Build Your Global Future
              </h1>
              <p className="hero-subtitle text-white mt-4 opacity-75">
                Discover the best migration route for you and your family with tailored support every step of the way. Partner with certified experts.
              </p>
              
              <div className="hero-trust-badges mt-4">
                <span><FaCheckCircle className="text-success" /> 98% Success Rate</span>
                <span><FaShieldAlt className="text-primary" /> Certified Experts</span>
                <span><FaGlobeAmericas className="text-info" /> 10+ Countries</span>
              </div>
            </div>
            
            <div className="col-lg-5">
              <div className="migrate-form-wrapper shadow-lg p-4 p-md-4">
                <h3 className="migrate-form-title mb-1 text-center">Start Your Assessment</h3>
                <p className="migrate-form-subtitle mb-4 text-center">Get a customized migration roadmap</p>
                <form className="migrate-form-2026" onSubmit={quickForm}>
                  <div className="mb-3">
                    <label className="form-label small fw-bold text-dark"><FaUser className="me-2 text-primary" />Full Name</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Full Name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control modern-input"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label small fw-bold text-dark"><FaGlobeAmericas className="me-2 text-primary" />Target Country</label>
                    <select 
                      value={formData.country}
                      name="country" 
                      onChange={handleChange}
                      className="form-select modern-input"
                      required>
                      <option value="">Select Country to Migrate</option>
                      <optgroup label="Popular Destinations">
                        <option value="Canada">Canada</option>
                        <option value="Australia">Australia</option>
                        <option value="UK">United Kingdom (UK)</option>
                        <option value="USA">United States (USA)</option>
                        <option value="Germany">Germany</option>
                        <option value="UAE">United Arab Emirates (UAE)</option>
                        <option value="New Zealand">New Zealand</option>
                      </optgroup>
                      <optgroup label="Europe & Other Destinations">
                        <option value="Ireland">Ireland</option>
                        <option value="France">France</option>
                        <option value="Netherlands">Netherlands</option>
                        <option value="Singapore">Singapore</option>
                        <option value="Malta">Malta</option>
                        <option value="Sweden">Sweden</option>
                        <option value="Portugal">Portugal</option>
                        <option value="Spain">Spain</option>
                        <option value="Other">Other Country</option>
                      </optgroup>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label small fw-bold text-dark"><FaUsers className="me-2 text-success" />Email Address</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control modern-input"
                      required
                    />
                  </div>
                  <div className="mb-4">
                    <label className="form-label small fw-bold text-dark"><FaCheckCircle className="me-2 text-warning" />Whatsapp / Phone</label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="+91 (555) 000-0000"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control modern-input"
                      required
                    />
                  </div>
                  <button 
                    type="submit" 
                    className="primary-btn premium-btn w-100"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <span>Submitting Assessment...</span>
                    ) : (
                      <span>Get Free Consultation</span>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHY MIGRATE SECTION */}
      <section className="section bg-light-mesh">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2 className="section-title">Why Migrate Abroad?</h2>
            <div className="title-underline mx-auto"></div>
          </div>
          
          {/* 2x2 grid on mobile via col-6 */}
          <div className="row g-4">
            <div className="col-6 col-md-6 col-lg-3">
              <div className="home-feature-card glass-card hover-lift text-center h-100">
                <div className="home-feature-icon text-primary mb-3"><FaBriefcase /></div>
                <h3 className="fs-5">Career Growth</h3>
                <p className="text-muted small mb-0">Access to excellent global career opportunities</p>
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-3">
              <div className="home-feature-card glass-card hover-lift text-center h-100">
                <div className="home-feature-icon text-success mb-3"><FaHome /></div>
                <h3 className="fs-5">Better Living</h3>
                <p className="text-muted small mb-0">Experience a higher standard of living and safety</p>
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-3">
              <div className="home-feature-card glass-card hover-lift text-center h-100">
                <div className="home-feature-icon text-info mb-3"><FaGraduationCap /></div>
                <h3 className="fs-5">Quality Education</h3>
                <p className="text-muted small mb-0">World-class healthcare and education for your family</p>
              </div>
            </div>
            <div className="col-6 col-md-6 col-lg-3">
              <div className="home-feature-card glass-card hover-lift text-center h-100">
                <div className="home-feature-icon text-warning mb-3"><FaGlobeAmericas /></div>
                <h3 className="fs-5">Citizenship Path</h3>
                <p className="text-muted small mb-0">Clear pathways to permanent residency and citizenship</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PROCESS SECTION */}
      <section className="section">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2 className="section-title">Migration Process</h2>
            <div className="title-underline mx-auto"></div>
          </div>
          
          <div className="row g-4">
            {[
              { num: '1', title: 'Free Check', desc: 'Assess profile' },
              { num: '2', title: 'Evaluation', desc: 'Calculate score' },
              { num: '3', title: 'Documents', desc: 'Gather files' },
              { num: '4', title: 'Submit', desc: 'File application' },
              { num: '5', title: 'Track', desc: 'Monitor visa' },
              { num: '6', title: 'Settle', desc: 'Arrival help' }
            ].map((step, idx) => (
              <div key={idx} className="col-6 col-md-4 col-lg-2">
                <div className="process-step-2026 text-center glass-card hover-lift h-100">
                  <div className="step-number-wrapper mb-3">
                    <div className="step-number-2026">{step.num}</div>
                  </div>
                  <h6 className="fw-bold fs-6">{step.title}</h6>
                  <p className="small text-muted mb-0">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* DESTINATIONS SECTION - INTERACTIVE WORLD MAP */}
      <section className="section bg-light-mesh interactive-map-section" aria-label="Global Migration Destinations">
        <div className="container-fluid px-3 px-lg-5">
          <div className="section-header text-center mb-4">
            <h2 className="section-title">Global Destinations</h2>
            <p className="text-muted mt-2 fs-6">Select a country or click any pin to explore visa pathways, timelines, and requirements</p>
            <div className="title-underline mx-auto"></div>
          </div>

          {/* Quick Country Selector Tabs */}
          <div 
            className="country-pill-bar d-flex justify-content-center flex-wrap gap-2 mb-4" 
            role="tablist" 
            aria-label="Migration destinations list"
          >
            {mapDestinations.map((dest, idx) => (
              <button
                key={idx}
                type="button"
                role="tab"
                aria-selected={selectedCountry === idx}
                aria-controls={`country-panel-${idx}`}
                id={`country-tab-${idx}`}
                className={`country-pill-btn ${selectedCountry === idx ? 'active' : ''}`}
                onClick={() => setSelectedCountry(idx)}
              >
                <img src={dest.flag} alt="" className="pill-flag me-2" aria-hidden="true" />
                <span className="pill-name">{dest.country}</span>
              </button>
            ))}
          </div>
          
          <div className="world-map-container position-relative mx-auto" role="region" aria-label="Interactive world map">
            {/* World Map SVG Background */}
            <img 
              src="https://upload.wikimedia.org/wikipedia/commons/8/80/World_map_-_low_resolution.svg" 
              alt="Interactive World Map" 
              className="world-map-img"
              draggable="false"
            />
            
            {/* Accessible Map Pins */}
            {mapDestinations.map((dest, idx) => (
              <div 
                key={idx} 
                className={`map-pin-wrapper ${selectedCountry === idx ? 'active' : ''}`}
                style={{ top: dest.top, left: dest.left }}
              >
                <button
                  type="button"
                  aria-label={`Select ${dest.country}`}
                  aria-expanded={selectedCountry === idx}
                  className={`map-pin ${selectedCountry === idx ? 'active' : ''}`}
                  onClick={() => setSelectedCountry(idx)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setSelectedCountry(idx);
                    }
                  }}
                >
                  <div className="pin-pulse" aria-hidden="true"></div>
                  <img src={dest.flag} alt="" className="pin-flag" aria-hidden="true" />
                </button>
                <span 
                  className="pin-label-tag" 
                  onClick={() => setSelectedCountry(idx)}
                  role="button"
                  tabIndex={-1}
                  aria-hidden="true"
                >
                  {dest.country.replace(' Migration', '').replace(' Skilled Worker', '').replace(' Blue Card', '').replace(' Golden Visa', '')}
                </span>
              </div>
            ))}

            {/* Desktop Expansion Card (Smart Floating Overlay) */}
            {selectedCountry !== null && mapDestinations[selectedCountry] && (
              <div 
                id={`country-panel-${selectedCountry}`}
                role="tabpanel"
                aria-labelledby={`country-tab-${selectedCountry}`}
                className="map-expansion-card shadow-lg d-none d-md-block"
                style={{ 
                  top: mapDestinations[selectedCountry].pTop,
                  bottom: mapDestinations[selectedCountry].pBottom,
                  left: mapDestinations[selectedCountry].pLeft,
                  transform: mapDestinations[selectedCountry].pTrans
                }}
              >
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <img 
                      src={mapDestinations[selectedCountry].flag} 
                      alt="" 
                      className="rounded shadow-sm" 
                      style={{ width: '38px', height: '26px', objectFit: 'cover' }} 
                    />
                    <h4 className="fw-bold mb-0 text-dark fs-5">{mapDestinations[selectedCountry].country}</h4>
                  </div>
                  <button 
                    type="button" 
                    className="btn-close-card" 
                    aria-label="Close destination details"
                    onClick={(e) => { e.stopPropagation(); setSelectedCountry(null); }}
                  >
                    <FaTimes />
                  </button>
                </div>

                <div className="dest-meta-grid mb-3">
                  <div className="meta-item">
                    <span className="meta-label">Est. Cost</span>
                    <span className="meta-value text-teal fw-bold">{mapDestinations[selectedCountry].cost}</span>
                  </div>
                  <div className="meta-item">
                    <span className="meta-label">Processing</span>
                    <span className="meta-value text-dark fw-bold"><FaClock className="me-1 text-primary small" />{mapDestinations[selectedCountry].time}</span>
                  </div>
                </div>

                <div className="pathway-info mb-3">
                  <span className="pathway-label d-block text-muted small mb-1 fw-semibold">Popular Pathways</span>
                  <p className="pathway-desc mb-0 small text-dark fw-medium">
                    <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                    {mapDestinations[selectedCountry].details}
                  </p>
                </div>

                <button 
                  type="button" 
                  className="btn-check-eligibility w-100"
                  onClick={() => scrollToForm(mapDestinations[selectedCountry].country)}
                >
                  <span>Apply for {mapDestinations[selectedCountry].country.split(' ')[0]}</span>
                  <FaArrowRight className="ms-2 small" />
                </button>
              </div>
            )}
          </div>

          {/* Mobile Expansion Card (Stacked below map) */}
          {selectedCountry !== null && mapDestinations[selectedCountry] && (
            <div 
              className="mobile-expansion-card shadow-lg d-md-none mt-4 mx-auto p-4 bg-white rounded-4"
              role="tabpanel"
              aria-labelledby={`country-tab-${selectedCountry}`}
            >
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center gap-2">
                  <img 
                    src={mapDestinations[selectedCountry].flag} 
                    alt="" 
                    className="rounded shadow-sm" 
                    style={{ width: '36px', height: '24px', objectFit: 'cover' }} 
                  />
                  <h4 className="fw-bold mb-0 text-dark fs-5">{mapDestinations[selectedCountry].country}</h4>
                </div>
                <button 
                  type="button" 
                  className="btn-close-card" 
                  aria-label="Close destination details"
                  onClick={() => setSelectedCountry(null)}
                >
                  <FaTimes />
                </button>
              </div>

              <div className="dest-meta-grid mb-3">
                <div className="meta-item">
                  <span className="meta-label">Est. Cost</span>
                  <span className="meta-value text-teal fw-bold">{mapDestinations[selectedCountry].cost}</span>
                </div>
                <div className="meta-item">
                  <span className="meta-label">Processing</span>
                  <span className="meta-value text-dark fw-bold"><FaClock className="me-1 text-primary small" />{mapDestinations[selectedCountry].time}</span>
                </div>
              </div>

              <div className="pathway-info mb-3">
                <span className="pathway-label d-block text-muted small mb-1 fw-semibold">Pathways</span>
                <p className="pathway-desc mb-0 small text-dark fw-medium">
                  <FaCheckCircle className="text-success me-2" />
                  {mapDestinations[selectedCountry].details}
                </p>
              </div>

              <button 
                type="button" 
                className="btn-check-eligibility w-100"
                onClick={() => scrollToForm(mapDestinations[selectedCountry].country)}
              >
                <span>Apply for {mapDestinations[selectedCountry].country.split(' ')[0]}</span>
                <FaArrowRight className="ms-2 small" />
              </button>
            </div>
          )}
        </div>
      </section>

      {/* COUNTRY COMPARISON TOOL */}
      <section className="section">
        <div className="container">
          <CountryComparison />
        </div>
      </section>

      {/* LIBA MIGRATION HIGHLIGHT */}
      <section className="section liba-highlight-2026">
        <div className="container">
          <div className="glass-card gradient-card liba-box p-4 p-md-5">
            <div className="row align-items-center">
              <div className="col-lg-8 text-center text-lg-start">
                <h3 className="fw-bold text-white mb-3">🌍 Liba Migration Services</h3>
                <p className="text-white opacity-75 mb-0">
                  Partner with our sister concern, Liba Migration Services, for specialized Canada PR, Work Permits, and global immigration solutions. Expert guidance, transparent process, and proven success.
                </p>
              </div>
              <div className="col-lg-4 text-center text-lg-end mt-4 mt-lg-0">
                <Link to="/LibaMigration" className="liba-btn">
                  Explore Liba Services &rarr;
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="section bg-light-mesh">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2 className="section-title">Frequently Asked Questions</h2>
            <div className="title-underline mx-auto"></div>
          </div>
          <div className="faq-list-2026 mx-auto" style={{ maxWidth: '800px' }}>
            {migrateFaqs.map((faq, i) => (
              <div key={i} className="faq-item-2026 glass-card mb-3" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <div className="faq-question-2026 d-flex justify-content-between align-items-center p-4 cursor-pointer">
                  <span className="fw-bold">{faq.q}</span>
                  <FaChevronDown className={`faq-icon transition-all ${openFaq === i ? 'rotate-180' : ''}`} />
                </div>
                {openFaq === i && (
                  <div className="faq-answer-2026 p-4 pt-0 text-muted border-top">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <CtaBand
        title="Which migration route is actually open to you?"
        body="Points systems, occupation lists and provincial streams change constantly. A free profile assessment tells you which ones you qualify for today, and what would move the needle."
        primary={{ to: "/consultationForm", label: "Get a free assessment" }}
        secondary={{ to: "/canada-pr", label: "Explore Canada PR" }}
      />
    </div>
  );
}